import React from 'react'
import Link from '../utils/link'
import parse from 'html-react-parser'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const FourItems = ({items}) => {

  const props = {
    onMouseEnter: () => window?._handleMouseEnter('View'),
    onMouseLeave: () => window?._handleMouseLeave(),
  }

  return (
    <section className="four-items">
      <div className="four-items__inner">
        { items.map((el, i) => (
          <Link to={el.link} className="four-items__item" data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease' key={i} {...props}>
            { el.image?.localFile && <GatsbyImage image={getImage(el.image.localFile)} alt={el.image.altText} /> }
            <div className="four-items__cap">
              { el.title && <h4>{parse(el.title)}</h4> }
              { el.subtitle && <span>{parse(el.subtitle)}</span> }
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default FourItems